import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { HowItWorks } from '../components/sales/HowItWorks';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { WhatYouLearnSection } from '../components/sales/WhatYouLearnSection';
import { OfferSection } from '../components/sales/OfferSection';
import { BonusSection } from '../components/sales/BonusSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { ImageCarouselSection } from '../components/sales/ImageCarouselSection';
import { AboutSection } from '../components/sales/AboutSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { FAQSection } from '../components/sales/FAQSection';
import { FinalCTASection } from '../components/sales/FinalCTASection';
export function SalesLandingPage() {
  return <div className="min-h-screen bg-brand-dark text-brand-light antialiased selection:bg-brand-gold selection:text-black" data-id="element-331">
      <main data-id="element-332">
        <HeroSection data-id="element-333" />
        <ProblemSection data-id="element-334" />
        <MechanismSection data-id="element-335" />
        <HowItWorks data-id="element-336" />
        <BeforeAfterSection data-id="element-337" />
        <WhatYouLearnSection data-id="element-338" />
        <OfferSection data-id="element-339" />
        <BonusSection data-id="element-340" />
        <TestimonialsSection data-id="element-341" />
        <ImageCarouselSection data-id="element-342" />
        <AboutSection data-id="element-343" />
        <GuaranteeSection data-id="element-344" />
        <FAQSection data-id="element-345" />
        <FinalCTASection data-id="element-346" />
      </main>

      <footer className="bg-black py-12 border-t border-white/10 text-center text-sm text-gray-600" data-id="element-347">
        <div className="container mx-auto px-4" data-id="element-348">
          <img src="https://i.postimg.cc/sDqXRT0X/logo-nuevo.png" alt="Carmen Otero - Protocolo Maestro" className="h-28 md:h-36 w-auto mx-auto mb-6" data-id="element-349" />

          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-350">
            <a href="#" className="hover:text-brand-gold transition" data-id="element-351">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-brand-gold transition" data-id="element-352">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-brand-gold transition" data-id="element-353">
              Descargo de Responsabilidad
            </a>
          </div>

          <p className="max-w-3xl mx-auto mb-6 text-xs leading-relaxed" data-id="element-354">
            *Descargo de responsabilidad médica: Este sitio web no está
            destinado a proporcionar diagnóstico médico, tratamiento o consejo
            médico. La información proporcionada en este sitio web es solo para
            fines informativos. Consulte a su médico antes de comenzar cualquier
            rutina. Los testimonios y ejemplos utilizados son resultados
            atípicos y no pretenden garantizar que todos logren resultados
            iguales.
          </p>

          <p data-id="element-355">
            &copy; {new Date().getFullYear()} Carmen Otero - Protocolo Maestro.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}